import React from "react";

function NoDataFound({ message }) {
  return (
    <div className="w-full h-full flex justify-center items-center flex-col gap-3">
      <img src="/Images/noDataImage.svg" className="h-[10rem] w-full" alt="" />
      <h4 className="font-normal text-center">{message}</h4>
    </div>
  );
}

export default NoDataFound;
